import React, { useState, useEffect, useRef } from 'react';

import { Dialog, Card, Collapse } from '@mui/material';
import { images, icons, markers } from "../../helpers/constants";
import { Trans, useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import SafetyZoneMap from '../Map/SafetyZoneMap';
import { copyToClipboard, downloadPDF, fixDate } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


const StolenModeModal = ({show, onClose, info, type, device, onSave, download}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [centralName, setCentralName] = useState()
    const [errorText, setErrorText] = useState()

    const [startDate, setStartDate] = useState(dayjs().subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs())


    const [selectedType, setSelectedType] = useState(-1)
    const [selectedFormat, setSelectedFormat] = useState(null)

    const [confirmation, setConfirmation] = useState(false)
    const [additionalInfo, setAdditionalInfo] = useState("")

    const [imgFile, setImgFile] = useState()

    const [currentImg, setCurrentImg] = useState()
    const [copySuccess, setCopySuccess] = useState(false)
    const inputFile = useRef(null);


    const handleClose = () => {
        onClose()
        setTimeout(() => {
            setSelectedType(-1)

        }, 200);
      //  setShow(false)
    }

    const handleSave = (type) => {
           let data = {}
        let reset = false
        switch(type){
            case "additional":
                data.deviceid = device?.id
                data.action = "configure"
                data.description = additionalInfo
            break;
            case "activate":
                data.deviceid = device?.id
                data.action = "activate"
            break;
            default: data = {}
        }
        onSave(data, reset)
    }


    const handleChange = (type, e) => {
        switch(type){
            case "info":
                setCentralName(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }


    useEffect(() => {
        setAdditionalInfo(info?.description ?? "")
    }, [info])
    

    const shareLink = () => {
        alert("TJO")
    }

    const copyLink = (url) => {
        copyToClipboard(url)
        .then((result) => {
            setCopySuccess(true)
            setTimeout(() => {
                setCopySuccess(false)
            }, 1000);
		})
		.catch((error) => {
			console.log("Copy failed:", error); // trigger failure action
		});
    }

    const uploadHandler = () => {
        inputFile.current.click();
    }

    const handleUploadedImg = (imgfile) => {
        if (imgfile) {
            // Create a URL for the file
            const imageUrl = URL.createObjectURL(imgfile);
            // Update your component's state to reflect the new image
            setCurrentImg(imageUrl);
            setImgFile(imgfile)
        }
    }

    const clearImg = () => {
        setCurrentImg()
        setImgFile()
    }

    const disabledContent = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={icons.stolenmode} alt=""/>
                    <h3 className="ms-2">{t("settings.stolen_mode")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
            <div className="p-3">
                <p className="dark-grey text-center pb-3">{t("settings.stolen_mode_tos")}</p>
                <div className="d-flex align-items-center mt-3">
                    <div className={`${confirmation ? "bg-checked" : "bg-grey"} size_20 border-sm d-flex justify-content-center p-1 cursor-pointer`} onClick={() => setConfirmation(!confirmation)}>
                        {confirmation && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>
                    <p className="thin dark-grey ms-3">{t("setting.confirmation")}</p>
                </div>
            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
               <Button onClick={() => handleSave("activate")} disabled={!confirmation} btnClass={`btn-primary ${!confirmation ? "disabled" : ""}`}>{t("settings.enable")}</Button>
            </div>
            </>
        )
    }



    const additionalContent = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={icons.stolenmode} alt=""/>
                    <h3 className="ms-2">{t("settings.additional")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
            <div className="p-3">
                <p className="dark-grey text-center pb-3">{t("settings.additional_info_desc")}</p>
                <div className="d-flex justify-content-between">
                    <div className="userimage mx-auto">
                        <img src={currentImg ? currentImg : images.placeholder_img} alt="" className="w-100"/>
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <Button icon={icons.plus} onClick={uploadHandler} btnClass="btn-secondary mb-3 primary">
							{t("settings.add_picture")}
						</Button>
                        <input
                            type="file"
                            id="file"
                            className="cursor-pointer invisible"
                            onChange={(e) => handleUploadedImg(e.target.files[0])}
                            ref={inputFile}
                            style={{ display: "none" }}
                        />
						<Button 
                            icon={icons.trashcan} 
                            onClick={() => clearImg()} 
                            btnClass="btn-secondary red"
                            iconColor={"danger-icon"}
                        >
							{t("settings.remove_picture")}
						</Button>
                    </div>
                </div>
                <textarea rows={3} placeholder={t("settings.additional_info_placeholder")} defaultValue={additionalInfo} onChange={(event) => setAdditionalInfo(event.target.value)} className="p mt-3 pb-3 form-control text-area-boy bg-light-grey" />    

            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
               <Button onClick={() => handleSave("additional")} btnClass={`btn-primary `}>{t("settings.save")}</Button>
            </div>
            </>
        )
    }


    const linkContent = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={icons.stolenmode} alt=""/>
                    <h3 className="ms-2">{t("settings.stolen_mode_link")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
            <div className="p-3">
                <p className="dark-grey text-center pb-3">{t("settings.stolen_mode_link_desc")}</p>
                <form>
                    <div className="form-group d-flex align-items-center position-relative">
                        <input
                            type={"text"}
                            className="form-control bg-light-grey p-2 pe-5"
                            id="text"
                            value={info?.url ?? ""}
                            placeholder=""
                            readOnly={true}
                        />
                        <img src={copySuccess ? icons.radio_checked : icons.copy} onClick={() => copyLink(info?.url)} className={`${copySuccess ? "": "inp-link-icon"} position-absolute size_15 ms-2 cursor-pointer end-0 me-2`} alt="" />
                    </div>
                </form>
            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary">{t("settings.close")}</Button>
               {/* <Button onClick={() => shareLink("")} btnClass={`btn-primary`}>{t("settings.share")}</Button> */}
            </div>
            </>
        )
    }

    const typeRender = () => {
        switch (type){
            case "activate":
                return disabledContent()
            case "additional":
                return additionalContent()
            case "link":
                return linkContent()
            default: return null
        }
    }


return(
    <>
    <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
        <Card className="settings-dialog d-flex flex-column">
            <div className="w-100 h-100">
                {typeRender()}
            </div>
        </Card>
    </Dialog>
    </>
)
}

export default StolenModeModal;